var _path, _rect, _path2, _rect2, _rect3, _rect4, _rect5, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgCalendar50 = function SvgCalendar50(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 88,
    height: 95,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#D9D9D9",
    d: "M.364 27.645h87.557V90.6a4 4 0 0 1-4 4H4.364a4 4 0 0 1-4-4z"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 87.557,
    height: 87.557,
    x: 0.364,
    y: 7.043,
    fill: "#C3C3C3",
    rx: 4
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#EBEBEB",
    d: "M.364 29.5h87.557v61.1a4 4 0 0 1-4 4H4.364a4 4 0 0 1-4-4z"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 12.885,
    height: 7.35,
    x: 11.14,
    y: 0.6,
    fill: "#848484",
    rx: 1,
    transform: "rotate(90 11.14 .6)"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    width: 12.885,
    height: 7.35,
    x: 35.593,
    y: 0.6,
    fill: "#848484",
    rx: 1,
    transform: "rotate(90 35.593 .6)"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    width: 12.885,
    height: 7.35,
    x: 60.046,
    y: 0.6,
    fill: "#848484",
    rx: 1,
    transform: "rotate(90 60.046 .6)"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    width: 12.885,
    height: 7.35,
    x: 84.497,
    y: 0.6,
    fill: "#848484",
    rx: 1,
    transform: "rotate(90 84.497 .6)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#848484",
    d: "M39.207 48.938H23.655v8.208q1.008-1.248 2.88-2.016a9.9 9.9 0 0 1 3.984-.816q3.84 0 6.288 1.68t3.552 4.32q1.104 2.592 1.104 5.568 0 5.52-3.168 8.88-3.12 3.36-8.928 3.36-5.472 0-8.736-2.736t-3.696-7.152h6.528q.432 1.92 1.92 3.072 1.536 1.152 3.888 1.152 2.832 0 4.272-1.776t1.44-4.704q0-2.976-1.488-4.512-1.44-1.584-4.272-1.584-2.016 0-3.36 1.008t-1.92 2.688H17.51V43.034h21.696zm30.89 0H54.545v8.208q1.008-1.248 2.88-2.016a9.9 9.9 0 0 1 3.984-.816q3.84 0 6.288 1.68t3.552 4.32q1.104 2.592 1.104 5.568 0 5.52-3.168 8.88-3.12 3.36-8.928 3.36-5.472 0-8.736-2.736t-3.696-7.152h6.528q.432 1.92 1.92 3.072 1.536 1.152 3.888 1.152 2.832 0 4.272-1.776t1.44-4.704q0-2.976-1.488-4.512-1.44-1.584-4.272-1.584-2.016 0-3.36 1.008t-1.92 2.688h-6.432V43.034h21.696z"
  })));
};
export { SvgCalendar50 as ReactComponent };
export default __webpack_public_path__ + "images/calendar-50.svg";